import _ from 'lodash';

export * from './orders';
export * from './customers';
export * from './products';
export * from './productsDelivery';
export * from './productsDataMatrix';
export * from './productsPrices';
export * from './productsDescription';
export * from './login';
export * from './tischOffensives';
export * from './users';

export const getPreloadingImagesEnable = (context) => _.get(context, 'state.preloadingImagesEnable');

export const getToast = (context) => _.get(context, 'state.toast');

export * from './productsForSearchPageGenreAndClusters';

export * from './getProductPriceSummary';

export * from './lineItemsToOrderData';
